(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category_banners"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.category-banners-section').forEach(function(section) {
      var track = section.querySelector('.category-banners__grid');
      var prevBtn = section.querySelector('.category-banners__arrow--prev');
      var nextBtn = section.querySelector('.category-banners__arrow--next');
      if (!track || !prevBtn || !nextBtn) return;

      function getScrollAmount() {
        var first = track.querySelector('.category-banner');
        if (!first) return track.offsetWidth * 0.8;
        var gap = parseFloat(getComputedStyle(track).gap) || 20;
        return first.offsetWidth + gap;
      }
      function updateArrows() {
        var canScroll = track.scrollWidth > track.offsetWidth + 2;
        prevBtn.disabled = track.scrollLeft <= 2;
        nextBtn.disabled = !canScroll || track.scrollLeft + track.offsetWidth >= track.scrollWidth - 2;
      }
      prevBtn.addEventListener('click', function() { track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' }); });
      nextBtn.addEventListener('click', function() { track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' }); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category_images"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.category-images-section').forEach(function(section) {
      var track = section.querySelector('.category-images__grid');
      var prevBtn = section.querySelector('.category-images__arrow--prev');
      var nextBtn = section.querySelector('.category-images__arrow--next');
      if (!track || !prevBtn || !nextBtn) return;

      function getScrollAmount() {
        var first = track.querySelector('.category-images__item');
        if (!first) return track.offsetWidth * 0.8;
        var gap = parseFloat(getComputedStyle(track).gap) || 20;
        return first.offsetWidth + gap;
      }
      function updateArrows() {
        var canScroll = track.scrollWidth > track.offsetWidth + 2;
        prevBtn.disabled = track.scrollLeft <= 2;
        nextBtn.disabled = !canScroll || track.scrollLeft + track.offsetWidth >= track.scrollWidth - 2;
      }
      prevBtn.addEventListener('click', function() { track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' }); });
      nextBtn.addEventListener('click', function() { track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' }); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured_collection"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.featured-collection--scrollable').forEach(function(section) {
      var track = section.querySelector('.featured-collection__grid');
      var prevBtn = section.querySelector('.featured-collection__arrow--prev');
      var nextBtn = section.querySelector('.featured-collection__arrow--next');
      if (!track || !prevBtn || !nextBtn) return;

      function getScrollAmount() {
        var first = track.querySelector('.product-card');
        if (!first) return track.offsetWidth * 0.8;
        var gap = parseFloat(getComputedStyle(track).gap) || 20;
        return first.offsetWidth + gap;
      }
      function updateArrows() {
        prevBtn.disabled = track.scrollLeft <= 2;
        nextBtn.disabled = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 2;
      }
      prevBtn.addEventListener('click', function() { track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' }); });
      nextBtn.addEventListener('click', function() { track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' }); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    /* ===== Desktop search modal ===== */
    var modal = document.getElementById('search-modal');
    var toggle = document.getElementById('search-toggle');
    var backdrop = document.getElementById('search-backdrop');
    var closeBtn = document.getElementById('search-close');
    var input = document.getElementById('search-input');
    var results = document.getElementById('search-results');
    var debounceTimer = null;

    function openSearch() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      setTimeout(function() { input.focus(); }, 50);
    }

    function closeSearch() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      input.value = '';
      results.innerHTML = '';
    }

    if (toggle) toggle.addEventListener('click', openSearch);
    var toggleMobile = document.getElementById('search-toggle-mobile');
    if (toggleMobile) toggleMobile.addEventListener('click', openSearch);
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    if (backdrop) backdrop.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeSearch();
    });

    var searchBanners = document.getElementById('search-banners');

    if (input) {
      input.addEventListener('input', function() {
        var query = this.value.trim();
        clearTimeout(debounceTimer);

        if (query.length < 2) {
          results.innerHTML = '';
          if (searchBanners) searchBanners.classList.remove('is-hidden');
          return;
        }

        if (searchBanners) searchBanners.classList.add('is-hidden');

        debounceTimer = setTimeout(function() {
          var modal = document.getElementById('search-modal');
          var currency = (modal && modal.dataset.currency) ? modal.dataset.currency : 'LKR';
          var offLabel = (modal && modal.dataset.offLabel) ? modal.dataset.offLabel : 'off';
          function formatMoney(amount) {
            var num = parseFloat(amount);
            if (isNaN(num)) return '';
            var str = num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            return currency + ' ' + str;
          }

          fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
            .then(function(r) { return r.json(); })
            .then(function(data) {
              var products = data.resources && data.resources.results && data.resources.results.products
                ? data.resources.results.products
                : [];

              if (products.length === 0) {
                results.innerHTML = '<p class="search-modal__empty" style="grid-column:1/-1">No products found</p>';
                return;
              }

              var html = '';
              products.forEach(function(p) {
                var priceVal = parseFloat(p.price) || 0;
                var compareVal = parseFloat(p.compare_at_price_min) || 0;
                var onSale = compareVal > 0 && priceVal < compareVal;
                var salePercent = onSale ? Math.round((compareVal - priceVal) / compareVal * 100) : 0;
                var img = p.image
                  ? '<img src="' + p.image + '&width=400' + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy">'
                  : '';
                var badge = onSale
                  ? '<span class="search-modal__result-badge" aria-hidden="true">' + salePercent + '% ' + offLabel + '</span>'
                  : '';
                var priceHtml = onSale
                  ? '<span class="search-modal__result-compare-at">' + formatMoney(compareVal) + '</span><span class="search-modal__result-sale-price">' + formatMoney(priceVal) + '</span>'
                  : formatMoney(priceVal);
                var title = (p.title || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
                html += '<a href="' + (p.url || '#') + '" class="search-modal__result">'
                  + '<div class="search-modal__result-image">' + img + badge + '</div>'
                  + '<div class="search-modal__result-info">'
                  + '<p class="search-modal__result-title">' + title + '</p>'
                  + '<p class="search-modal__result-price">' + priceHtml + '</p>'
                  + '</div></a>';
              });
              results.innerHTML = html;
            })
            .catch(function() {
              results.innerHTML = '';
            });
        }, 300);
      });
    }

    /* ===== Mobile menu ===== */
    var mobileMenu = document.getElementById('mobile-menu');
    var mobileOverlay = document.getElementById('mobile-menu-overlay');
    var mobileToggle = document.getElementById('mobile-menu-toggle');
    var mobileClose = document.getElementById('mobile-menu-close');

    function openMobileMenu() {
      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      mobileOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeMobileMenu() {
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      mobileOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (mobileToggle) mobileToggle.addEventListener('click', openMobileMenu);
    if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
    if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

    var accordionBtns = document.querySelectorAll('[data-mobile-accordion]');
    accordionBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = this.closest('.mobile-menu__item');
        var wasOpen = item.classList.contains('is-open');

        accordionBtns.forEach(function(b) {
          b.closest('.mobile-menu__item').classList.remove('is-open');
        });

        if (!wasOpen) {
          item.classList.add('is-open');
        }
      });
    });

    /* ===== Header scroll behavior ===== */
    var header = document.getElementById('site-header');
    if (header) {
      var forceTransparent = document.body.classList.contains('template-index');
      var announcementBar = document.querySelector('.announcement-bar');
      var announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;

      if (!forceTransparent) {
        header.classList.add('is-scrolled');
      }

      function updateHeader() {
        var offset = Math.max(0, announcementHeight - window.scrollY);
        header.style.top = offset + 'px';
        if (forceTransparent) {
          header.classList.toggle('is-scrolled', window.scrollY > announcementHeight);
        }
      }

      updateHeader();
      window.addEventListener('scroll', updateHeader, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-cart-discount]');
    if (!root) return;

    var form = root.querySelector('[data-discount-form]');
    var input = root.querySelector('#cart-discount-input');
    var messageEl = root.querySelector('[data-discount-message]');
    var applyBtn = form ? form.querySelector('.cart-page__discount-apply') : null;
    var busy = false;

    function showMessage(text, type) {
      if (!messageEl) return;
      messageEl.textContent = text;
      messageEl.hidden = !text;
      messageEl.classList.remove('cart-page__discount-message--error', 'cart-page__discount-message--success');
      if (type) messageEl.classList.add('cart-page__discount-message--' + type);
    }

    function setBusy(state) {
      busy = state;
      if (applyBtn) applyBtn.disabled = state;
      root.querySelectorAll('[data-remove-discount]').forEach(function(btn) {
        btn.disabled = state;
      });
    }

    function discountApplied(cart, code) {
      var apps = cart.cart_level_discount_applications || [];
      if (!code) return apps.length === 0;
      var normalized = code.trim().toLowerCase();
      return apps.some(function(app) {
        return app.title && app.title.toLowerCase() === normalized;
      });
    }

    function updateDiscount(code) {
      if (busy) return Promise.resolve();
      setBusy(true);
      showMessage('', null);

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: code })
      })
        .then(function(response) {
          return response.json().then(function(cart) {
            if (!response.ok) throw new Error(cart.description || cart.message || 'Discount update failed');
            return cart;
          });
        })
        .then(function(cart) {
          if (code && !discountApplied(cart, code)) {
            throw new Error(root.dataset.msgInvalid);
          }
          window.location.reload();
        })
        .catch(function(error) {
          setBusy(false);
          showMessage(error.message || root.dataset.msgError, 'error');
        });
    }

    if (form) {
      form.addEventListener('submit', function(event) {
        event.preventDefault();
        var code = input ? input.value.trim() : '';
        if (!code) {
          showMessage(root.dataset.msgEmpty, 'error');
          return;
        }
        updateDiscount(code);
      });
    }

    root.querySelectorAll('[data-remove-discount]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        updateDiscount('');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function() {
    var track = document.getElementById('cats-track');
    if (track) {
      var prevBtn = track.parentElement.querySelector('.collection-cats__arrow--prev');
      var nextBtn = track.parentElement.querySelector('.collection-cats__arrow--next');
      function getScrollAmount() {
        var firstCard = track.querySelector('.sub-collection');
        if (!firstCard) return track.offsetWidth * 0.8;
        var style = getComputedStyle(track);
        var gap = parseFloat(style.gap) || 16;
        return firstCard.offsetWidth + gap;
      }

      function updateArrows() {
        if (prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
        if (nextBtn) nextBtn.disabled = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 2;
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { track.scrollBy({ left: -getScrollAmount() }); });
      if (nextBtn) nextBtn.addEventListener('click', function() { track.scrollBy({ left: getScrollAmount() }); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    }

    var drawer = document.getElementById('filter-drawer');
    var overlay = document.getElementById('filter-overlay');
    var toggleBtn = document.getElementById('filter-toggle');
    var closeBtn = document.getElementById('filter-drawer-close');
    var applyBtn = document.getElementById('filter-drawer-apply');

    function openDrawer() {
      if (drawer) drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (drawer) drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (toggleBtn) toggleBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    var sortWrap = document.getElementById('sort-dropdown-wrap');
    var sortTrigger = document.getElementById('sort-dropdown-trigger');
    var sortDropdown = document.getElementById('sort-dropdown');
    if (sortWrap && sortTrigger && sortDropdown) {
      function openSortDropdown() {
        sortWrap.classList.add('is-open');
        sortTrigger.setAttribute('aria-expanded', 'true');
        sortDropdown.setAttribute('aria-hidden', 'false');
      }
      function closeSortDropdown() {
        sortWrap.classList.remove('is-open');
        sortTrigger.setAttribute('aria-expanded', 'false');
        sortDropdown.setAttribute('aria-hidden', 'true');
      }
      sortTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        if (sortWrap.classList.contains('is-open')) closeSortDropdown();
        else openSortDropdown();
      });
      document.addEventListener('click', function(e) {
        if (sortWrap.classList.contains('is-open') && !sortWrap.contains(e.target)) closeSortDropdown();
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && sortWrap.classList.contains('is-open')) closeSortDropdown();
      });
    }

    function applyFiltersFromForm(sourceForm) {
      if (!sourceForm) return;
      var current = new URLSearchParams(window.location.search);
      var params = new URLSearchParams();

      if (current.get('sort_by')) {
        params.set('sort_by', current.get('sort_by'));
      }

      sourceForm.querySelectorAll('input[type="checkbox"]:checked').forEach(function(input) {
        params.append(input.name, input.value);
      });

      sourceForm.querySelectorAll('[data-price-min-hidden], [data-price-max-hidden]').forEach(function(input) {
        if (!input.value) return;
        var centsValue = parseFloat(input.value);
        if (isNaN(centsValue)) return;
        var sliderWrap = input.closest('[data-price-slider]');
        var rangeMax = sliderWrap ? parseFloat(sliderWrap.getAttribute('data-range-max')) : null;
        if (input.hasAttribute('data-price-min-hidden') && centsValue <= 0) return;
        if (input.hasAttribute('data-price-max-hidden') && rangeMax !== null && centsValue >= rangeMax) return;
        params.set(input.name, String(Math.round(centsValue)));
      });

      window.location.search = params.toString();
    }

    function bindFilterCheckboxes(scopeForm) {
      if (!scopeForm) return;
      scopeForm.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
        cb.addEventListener('change', function() {
          if (cb.hasAttribute('data-filter-exclusive') && cb.checked) {
            scopeForm.querySelectorAll('input[type="checkbox"][name="' + cb.name + '"]').forEach(function(other) {
              if (other !== cb) other.checked = false;
            });
          }

          if (cb.dataset.urlToAdd && cb.dataset.urlToRemove && !cb.hasAttribute('data-filter-exclusive')) {
            window.location.href = cb.checked ? cb.dataset.urlToAdd : cb.dataset.urlToRemove;
            return;
          }

          applyFiltersFromForm(scopeForm);
        });
      });
    }

    function formatCurrencyValue(cents) {
      var n = Number(cents || 0) / 100;
      return 'LKR ' + n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function initPriceSliders(scopeForm, autoApply) {
      if (!scopeForm) return;
      scopeForm.querySelectorAll('[data-price-slider]').forEach(function(sliderWrap) {
        var minRange = sliderWrap.querySelector('[data-price-min]');
        var maxRange = sliderWrap.querySelector('[data-price-max]');
        var minHidden = sliderWrap.querySelector('[data-price-min-hidden]');
        var maxHidden = sliderWrap.querySelector('[data-price-max-hidden]');
        var minLabel = sliderWrap.querySelector('[data-price-min-label]');
        var maxLabel = sliderWrap.querySelector('[data-price-max-label]');
        if (!minRange || !maxRange || !minHidden || !maxHidden) return;

        var rangeMax = parseFloat(sliderWrap.getAttribute('data-range-max')) || 0;
        var minGap = 100;

        function syncUI() {
          var minVal = Math.min(parseFloat(minRange.value || 0), parseFloat(maxRange.value || rangeMax));
          var maxVal = Math.max(parseFloat(maxRange.value || rangeMax), minVal);
          if (maxVal - minVal < minGap) {
            if (document.activeElement === minRange) minVal = maxVal - minGap;
            else maxVal = minVal + minGap;
          }
          minVal = Math.max(0, Math.min(minVal, rangeMax));
          maxVal = Math.max(0, Math.min(maxVal, rangeMax));
          minRange.value = minVal;
          maxRange.value = maxVal;
          minHidden.value = minVal;
          maxHidden.value = maxVal;
          if (minLabel) minLabel.textContent = formatCurrencyValue(minVal);
          if (maxLabel) maxLabel.textContent = formatCurrencyValue(maxVal);
        }

        minRange.addEventListener('input', syncUI);
        maxRange.addEventListener('input', syncUI);
        minRange.addEventListener('change', function() { if (autoApply) applyFiltersFromForm(scopeForm); });
        maxRange.addEventListener('change', function() { if (autoApply) applyFiltersFromForm(scopeForm); });
        syncUI();
      });
    }

    function correctStalePriceFilterUrl(sourceForm) {
      if (!sourceForm) return;
      var params = new URLSearchParams(window.location.search);
      var needsUpdate = false;

      sourceForm.querySelectorAll('[data-price-min-hidden], [data-price-max-hidden]').forEach(function(input) {
        var urlValue = params.get(input.name);
        if (urlValue === null) return;
        if (String(Math.round(parseFloat(input.value))) !== urlValue) needsUpdate = true;
      });

      if (needsUpdate) applyFiltersFromForm(sourceForm);
    }

    var drawerForm = document.getElementById('filter-form-drawer');
    if (applyBtn) {
      applyBtn.addEventListener('click', function() {
        applyFiltersFromForm(drawerForm);
      });
    }
    initPriceSliders(drawerForm, false);

    var form = document.getElementById('filter-form');
    if (!form) return;

    bindFilterCheckboxes(form);
    bindFilterCheckboxes(drawerForm);

    initPriceSliders(form, true);
    correctStalePriceFilterUrl(form);

    var loader = document.getElementById('infinite-loader');
    var grid = document.getElementById('product-grid');
    if (!loader || !grid) return;

    var loading = false;
    var nextUrl = loader.dataset.next;

    var observer = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting && !loading && nextUrl) {
        loading = true;
        fetch(nextUrl)
          .then(function(res) { return res.text(); })
          .then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newGrid = doc.getElementById('product-grid');
            var newLoader = doc.getElementById('infinite-loader');

            if (newGrid) {
              var items = newGrid.children;
              while (items.length > 0) {
                grid.appendChild(items[0]);
              }
            }

            if (newLoader) {
              nextUrl = newLoader.dataset.next;
            } else {
              nextUrl = null;
              loader.remove();
            }

            loading = false;
          })
          .catch(function() {
            loading = false;
          });
      }
    }, { rootMargin: '600px' });

    observer.observe(loader);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    var carousel = document.getElementById('product-carousel');
    var dotsContainer = document.getElementById('product-dots');
    var scrollContainer = carousel && carousel.closest('.product-page__images-scroll');
    var hasColorFilter = scrollContainer && scrollContainer.getAttribute('data-color-option-position');

    /* ===== Color filtering (index ranges like OLD_THEME) ===== */
    var productData = null;
    var scriptEl = document.querySelector('[data-product-json]');
    if (scriptEl) {
      try { productData = JSON.parse(scriptEl.textContent); } catch(e) {}
    }

    function buildColorRanges() {
      if (!productData || !hasColorFilter || !productData.media || !productData.variants) return null;
      var options = productData.options || [];
      var pos = 0;
      for (var i = 0; i < options.length; i++) {
        if (options[i] === 'Color' || options[i] === 'Colour') { pos = i + 1; break; }
      }
      if (pos === 0) return null;
      var optKey = 'option' + pos;
      var colorValues = [];
      var seen = {};
      productData.variants.forEach(function(v) {
        var val = v[optKey];
        if (val && !seen[val]) { seen[val] = true; colorValues.push(val); }
      });
      var pairs = [];
      colorValues.forEach(function(colorVal) {
        var variant = productData.variants.find(function(v) { return v[optKey] === colorVal; });
        if (!variant) return;
        var mediaId = (variant.featured_media && variant.featured_media.id) || (variant.featured_image && variant.featured_image.id);
        if (mediaId == null && variant.featured_image && variant.featured_image.src) {
          var idx = productData.media.findIndex(function(m) {
            return m.media_type !== 'video' && m.media_type !== 'external_video' && m.src === variant.featured_image.src;
          });
          if (idx !== -1) pairs.push({ color: colorVal, index: idx });
          return;
        }
        var idx = productData.media.findIndex(function(m) { return m.id === mediaId; });
        if (idx !== -1) pairs.push({ color: colorVal, index: idx });
      });
      pairs.sort(function(a, b) { return a.index - b.index; });
      return pairs;
    }

    function assignDataGroupImage() {
      if (!carousel || !dotsContainer) return;
      var pairs = buildColorRanges();
      var slides = carousel.querySelectorAll('.product-page__image');
      var dots = dotsContainer.querySelectorAll('.product-page__dot');
      if (!pairs || pairs.length === 0) {
        slides.forEach(function(el) { el.removeAttribute('data-group-image'); });
        return;
      }
      var starts = pairs.map(function(p) { return p.index; });
      var colors = pairs.map(function(p) { return p.color; });
      slides.forEach(function(slide, r) {
        var color = null;
        for (var i = starts.length - 1; i >= 0; i--) {
          if (r >= starts[i]) { color = colors[i]; break; }
        }
        slide.setAttribute('data-group-image', color || colors[0]);
      });
      dots.forEach(function(dot, r) {
        var color = null;
        for (var i = starts.length - 1; i >= 0; i--) {
          if (r >= starts[i]) { color = colors[i]; break; }
        }
        dot.setAttribute('data-group-image', color || colors[0]);
      });
    }

    function getSelectedColor() {
      var form = document.getElementById('product-form');
      if (!form) return null;
      var swatch = form.querySelector('.product-page__color-swatch.is-active');
      return swatch ? swatch.getAttribute('data-value') : null;
    }

    function isMobile() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    function isVideoType(type) {
      return type === 'video' || type === 'external_video';
    }

    function reorderVisibleVideoFirst() {
      if (!carousel || !dotsContainer) return;
      var visibleSlides = Array.prototype.slice.call(carousel.querySelectorAll('.product-page__image:not(.product-page__image--hidden)'));
      var visibleDots = Array.prototype.slice.call(dotsContainer.querySelectorAll('.product-page__dot:not(.product-page__dot--hidden)'));
      if (visibleSlides.length === 0) return;
      visibleSlides.sort(function(a, b) {
        var aV = isVideoType(a.getAttribute('data-media-type'));
        var bV = isVideoType(b.getAttribute('data-media-type'));
        if (aV !== bV) return aV ? -1 : 1;
        return (parseInt(a.getAttribute('data-index'), 10) || 0) - (parseInt(b.getAttribute('data-index'), 10) || 0);
      });
      var sortedIndices = visibleSlides.map(function(s) { return s.getAttribute('data-index'); });
      visibleDots.sort(function(a, b) {
        return sortedIndices.indexOf(a.getAttribute('data-index')) - sortedIndices.indexOf(b.getAttribute('data-index'));
      });
      var first = carousel.firstChild;
      visibleSlides.forEach(function(s) { carousel.insertBefore(s, first); });
      first = dotsContainer.firstChild;
      visibleDots.forEach(function(d, i) {
        d.setAttribute('data-index', i);
        dotsContainer.insertBefore(d, first);
      });
    }

    function reorderAllByMediaIndex() {
      if (!carousel || !dotsContainer) return;
      var slides = Array.prototype.slice.call(carousel.querySelectorAll('.product-page__image'));
      var dots = Array.prototype.slice.call(dotsContainer.querySelectorAll('.product-page__dot'));
      slides.sort(function(a, b) { return (parseInt(a.getAttribute('data-index'), 10) || 0) - (parseInt(b.getAttribute('data-index'), 10) || 0); });
      dots.sort(function(a, b) { return (parseInt(a.getAttribute('data-index'), 10) || 0) - (parseInt(b.getAttribute('data-index'), 10) || 0); });
      slides.forEach(function(s) { carousel.appendChild(s); });
      dots.forEach(function(d, i) { d.setAttribute('data-index', i); dotsContainer.appendChild(d); });
    }

    function updateDisplayedImage(selectedColor) {
      if (!carousel || !dotsContainer) return;
      var slides = carousel.querySelectorAll('.product-page__image');
      var dots = dotsContainer.querySelectorAll('.product-page__dot');
      if (!hasColorFilter || !selectedColor) {
        slides.forEach(function(el) { el.classList.remove('product-page__image--hidden'); });
        dots.forEach(function(el) { el.classList.remove('product-page__dot--hidden'); });
      } else {
        slides.forEach(function(el) {
          var group = el.getAttribute('data-group-image');
          el.classList.toggle('product-page__image--hidden', group !== selectedColor);
        });
        dots.forEach(function(el) {
          var group = el.getAttribute('data-group-image');
          el.classList.toggle('product-page__dot--hidden', group !== selectedColor);
        });
      }
      if (isMobile()) {
        reorderVisibleVideoFirst();
      } else {
        reorderAllByMediaIndex();
      }
      carousel.scrollTo(0, 0);
      var visibleDots = dotsContainer.querySelectorAll('.product-page__dot:not(.product-page__dot--hidden)');
      visibleDots.forEach(function(dot, i) { dot.classList.toggle('is-active', i === 0); });
    }

    if (carousel && dotsContainer) {
      assignDataGroupImage();
      updateDisplayedImage(getSelectedColor());

      var lastMobile = isMobile();
      window.addEventListener('resize', function() {
        var nowMobile = isMobile();
        if (nowMobile !== lastMobile) {
          lastMobile = nowMobile;
          updateDisplayedImage(getSelectedColor());
        }
      });

      carousel.addEventListener('scroll', function() {
        var visible = carousel.querySelectorAll('.product-page__image:not(.product-page__image--hidden)');
        if (visible.length === 0) return;
        var slideWidth = visible[0].offsetWidth;
        var activeIndex = Math.min(Math.round(carousel.scrollLeft / slideWidth), visible.length - 1);
        var visibleDots = dotsContainer.querySelectorAll('.product-page__dot:not(.product-page__dot--hidden)');
        visibleDots.forEach(function(dot, i) { dot.classList.toggle('is-active', i === activeIndex); });
      }, { passive: true });

      dotsContainer.addEventListener('click', function(e) {
        var dot = e.target.closest('.product-page__dot');
        if (!dot || dot.classList.contains('product-page__dot--hidden')) return;
        var visible = carousel.querySelectorAll('.product-page__image:not(.product-page__image--hidden)');
        if (visible.length === 0) return;
        var visibleDots = dotsContainer.querySelectorAll('.product-page__dot:not(.product-page__dot--hidden)');
        var idx = Array.prototype.indexOf.call(visibleDots, dot);
        if (idx === -1) return;
        var slideWidth = visible[0].offsetWidth;
        carousel.scrollTo({ left: idx * slideWidth, behavior: 'smooth' });
      });
    }

    /* ===== Size chart drawer ===== */
    var scToggle = document.getElementById('size-chart-toggle');
    var scDrawer = document.getElementById('size-chart-drawer');
    var scOverlay = document.getElementById('size-chart-overlay');
    var scClose = document.getElementById('size-chart-close');

    function openSizeChart() {
      if (scDrawer) scDrawer.classList.add('is-open');
      if (scDrawer) scDrawer.setAttribute('aria-hidden', 'false');
      if (scOverlay) scOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeSizeChart() {
      if (scDrawer) scDrawer.classList.remove('is-open');
      if (scDrawer) scDrawer.setAttribute('aria-hidden', 'true');
      if (scOverlay) scOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (scToggle) scToggle.addEventListener('click', openSizeChart);
    if (scClose) scClose.addEventListener('click', closeSizeChart);
    if (scOverlay) scOverlay.addEventListener('click', closeSizeChart);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && scDrawer && scDrawer.classList.contains('is-open')) closeSizeChart();
    });

    var form = document.getElementById('product-form');
    if (!form) return;

    var productData = null;
    var scriptEl = document.querySelector('[data-product-json]');
    if (scriptEl) {
      try { productData = JSON.parse(scriptEl.textContent); } catch(e) {}
    }

    var variantInput = document.getElementById('product-variant-id');
    var optionButtons = form.querySelectorAll('[data-option-position]');
    var selectedOptions = {};

    optionButtons.forEach(function(btn) {
      if (btn.classList.contains('is-active')) {
        selectedOptions[btn.dataset.optionPosition] = btn.dataset.value;
      }
    });

    function updateSoldOutStates(opts) {
      if (!productData) return;
      optionButtons.forEach(function(btn) {
        if (!btn.classList.contains('product-page__size-btn')) return;
        var pos = btn.dataset.optionPosition;
        var val = btn.dataset.value;
        var hypothetical = {};
        for (var k in opts) hypothetical[k] = opts[k];
        hypothetical[pos] = val;
        var variant = productData.variants.find(function(v) {
          return Object.keys(hypothetical).every(function(p) {
            return v['option' + p] === hypothetical[p];
          });
        });
        var soldOut = !variant || !variant.available;
        btn.classList.toggle('is-sold-out', soldOut);
        btn.disabled = soldOut;
        var label = val + (soldOut ? ' (Sold out)' : '');
        btn.setAttribute('aria-label', label);
      });
    }

    updateSoldOutStates(selectedOptions);

    var addToCartBtn = form.querySelector('button[type="submit"]');
    function setAddToCartDisabled(variant) {
      if (addToCartBtn) addToCartBtn.disabled = !variant || !variant.available;
    }
    var initialVariant = productData && productData.variants.find(function(v) { return String(v.id) === String(variantInput.value); });
    setAddToCartDisabled(initialVariant);

    function updateOptionValueDisplays() {
      form.querySelectorAll('[data-option-index]').forEach(function(span) {
        var pos = parseInt(span.dataset.optionIndex, 10) + 1;
        if (selectedOptions[pos]) span.textContent = selectedOptions[pos];
      });
    }

    optionButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (this.disabled) return;
        var pos = this.dataset.optionPosition;
        var val = this.dataset.value;
        var isColorSwatch = this.classList.contains('product-page__color-swatch');

        if (isColorSwatch && productData) {
          selectedOptions[pos] = val;
          var firstVariantWithColor = productData.variants.find(function(v) { return v['option' + pos] === val; });
          if (firstVariantWithColor) {
            for (var p = 1; p <= 3; p++) {
              if (firstVariantWithColor['option' + p] !== undefined) selectedOptions[p] = firstVariantWithColor['option' + p];
            }
          }
          form.querySelectorAll('.product-page__size-btn').forEach(function(b) { b.classList.remove('is-active'); });
        } else {
          selectedOptions[pos] = val;
        }

        var siblings = form.querySelectorAll('[data-option-position="' + pos + '"]');
        siblings.forEach(function(s) { s.classList.remove('is-active'); });
        this.classList.add('is-active');

        if (isColorSwatch && typeof updateDisplayedImage === 'function') {
          updateDisplayedImage(val);
        }

        if (productData) {
          var variant = productData.variants.find(function(v) {
            return Object.keys(selectedOptions).every(function(p) {
              return v['option' + p] === selectedOptions[p];
            });
          });

          if (variant) {
            variantInput.value = variant.id;
            updateSoldOutStates(selectedOptions);
            updateOptionValueDisplays();
            setAddToCartDisabled(variant);
            var priceEl = document.getElementById('product-price');
            var compareEl = document.getElementById('product-price-compare');
            var badgeEl = document.getElementById('product-price-badge');
            var currency = productData.currency || 'LKR';
            var formatMoney = function(cents) {
              return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
            };
            if (priceEl) {
              priceEl.textContent = formatMoney(variant.price);
            }
            var onSale = variant.compare_at_price != null && variant.compare_at_price > variant.price;
            if (compareEl) {
              if (onSale) {
                compareEl.textContent = formatMoney(variant.compare_at_price);
                compareEl.classList.remove('product-page__price-compare--hidden');
                compareEl.removeAttribute('aria-hidden');
              } else {
                compareEl.textContent = '';
                compareEl.classList.add('product-page__price-compare--hidden');
                compareEl.setAttribute('aria-hidden', 'true');
              }
            }
            if (badgeEl) {
              if (onSale) {
                var percent = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
                badgeEl.textContent = percent + '% ' + (badgeEl.getAttribute('data-off-label') || 'off');
                badgeEl.classList.remove('product-page__sale-badge--hidden');
                badgeEl.removeAttribute('aria-hidden');
              } else {
                badgeEl.classList.add('product-page__sale-badge--hidden');
                badgeEl.setAttribute('aria-hidden', 'true');
              }
            }
            var url = new URL(window.location);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url);
          }
        }
      });
    });

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var variantId = variantInput.value;
      var v = productData && productData.variants.find(function(x) { return String(x.id) === String(variantId); });
      if (!v || !v.available) return;
      if (window.CartDrawer) {
        CartDrawer.addItem(parseInt(variantId, 10), 1);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function () {
    const section = document.querySelector('.password-page');
    if (!section) return;

    const dialog = section.querySelector('[data-password-dialog]');
    const openBtn = section.querySelector('[data-password-open]');
    const closeTargets = section.querySelectorAll('[data-password-close]');

    function openDialog() {
      if (!dialog) return;
      dialog.hidden = false;
      openBtn?.setAttribute('aria-expanded', 'true');
      section.querySelector('#password-input')?.focus();
    }

    function closeDialog() {
      if (!dialog) return;
      dialog.hidden = true;
      openBtn?.setAttribute('aria-expanded', 'false');
      openBtn?.focus();
    }

    openBtn?.addEventListener('click', openDialog);
    closeTargets.forEach((el) => el.addEventListener('click', closeDialog));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && dialog && !dialog.hidden) {
        closeDialog();
      }
    });

    if (section.querySelector('.password-page__login-errors')) {
      openDialog();
    }

    const countdown = section.querySelector('[data-password-countdown]');
    if (!countdown) return;

    const endRaw = countdown.dataset.countdownEnd;
    const endTime = Date.parse(endRaw);
    if (Number.isNaN(endTime)) return;

    const daysEl = countdown.querySelector('[data-countdown-days]');
    const hoursEl = countdown.querySelector('[data-countdown-hours]');
    const minsEl = countdown.querySelector('[data-countdown-mins]');
    const secsEl = countdown.querySelector('[data-countdown-secs]');

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function tick() {
      const remaining = Math.max(0, endTime - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const mins = Math.floor((totalSeconds % 3600) / 60);
      const secs = totalSeconds % 60;

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl) minsEl.textContent = pad(mins);
      if (secsEl) secsEl.textContent = pad(secs);

      if (remaining > 0) {
        window.setTimeout(tick, 1000);
      }
    }

    tick();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-get-the-look"]) return;
  try {
    
  (function() {
    var section = document.querySelector('.product-look');
    if (!section) return;

    var overlay = document.getElementById('look-modal-overlay');
    var modal = document.getElementById('look-modal');
    var closeBtn = document.getElementById('look-modal-close');
    var carousel = document.getElementById('look-modal-carousel');
    var dotsContainer = document.getElementById('look-modal-dots');
    var titleEl = document.getElementById('look-modal-title');
    var priceEl = document.getElementById('look-modal-price');
    var optionsEl = document.getElementById('look-modal-options');
    var atcBtn = document.getElementById('look-modal-atc');
    if (!modal || !overlay) return;

    var addLabel = modal.getAttribute('data-add-label') || 'Add to cart';
    var soldOutLabel = modal.getAttribute('data-sold-out-label') || 'Sold out';
    var colorLabel = modal.getAttribute('data-color-label') || 'Color';
    var sizeLabel = modal.getAttribute('data-size-label') || 'Select size';
    var currency = modal.getAttribute('data-currency') || 'LKR';

    var currentProduct = null;
    var selectedOptions = {};

    function formatMoney(cents) {
      return currency + ' ' + (cents / 100).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    function isColorOption(name) {
      return name === 'Color' || name === 'Colour';
    }

    function findVariant(opts) {
      if (!currentProduct || !currentProduct.variants) return null;
      return currentProduct.variants.find(function(v) {
        return Object.keys(opts).every(function(pos) {
          return v['option' + pos] === opts[pos];
        });
      });
    }

    function getVisibleSlides() {
      return carousel.querySelectorAll('.look-modal__slide:not(.look-modal__slide--hidden)');
    }

    function assignColorGroups() {
      if (!currentProduct || !currentProduct.has_color_filter) return;
      var ranges = currentProduct.color_ranges;
      if (!ranges || ranges.length === 0) return;
      ranges.sort(function(a, b) { return a.index - b.index; });
      var starts = ranges.map(function(r) { return r.index; });
      var colors = ranges.map(function(r) { return r.color; });
      var slides = carousel.querySelectorAll('.look-modal__slide');
      slides.forEach(function(slide) {
        var mi = parseInt(slide.getAttribute('data-media-index'), 10);
        var color = colors[0];
        for (var i = starts.length - 1; i >= 0; i--) {
          if (mi >= starts[i]) { color = colors[i]; break; }
        }
        slide.setAttribute('data-group-image', color);
      });
    }

    function filterByColor(color) {
      var allSlides = Array.prototype.slice.call(carousel.querySelectorAll('.look-modal__slide'));

      var visible = [];
      var hidden = [];
      allSlides.forEach(function(s) {
        var match = !color || s.getAttribute('data-group-image') === color;
        s.classList.toggle('look-modal__slide--hidden', !match);
        if (match) visible.push(s); else hidden.push(s);
      });

      visible.sort(function(a, b) {
        var aV = a.getAttribute('data-media-type') !== 'image';
        var bV = b.getAttribute('data-media-type') !== 'image';
        if (aV && !bV) return -1;
        if (!aV && bV) return 1;
        return (parseInt(a.getAttribute('data-media-index'), 10) || 0) -
               (parseInt(b.getAttribute('data-media-index'), 10) || 0);
      });

      visible.forEach(function(s) { carousel.appendChild(s); });
      hidden.forEach(function(s) { carousel.appendChild(s); });

      rebuildDots(visible.length);
      carousel.scrollTo(0, 0);

      allSlides.forEach(function(slide) {
        var video = slide.querySelector('video');
        if (video) video.pause();
      });
      if (visible.length > 0) {
        var firstVideo = visible[0].querySelector('video');
        if (firstVideo) {
          firstVideo.muted = true;
          try { firstVideo.play(); } catch(e) {}
        }
      }
    }

    function rebuildDots(count) {
      dotsContainer.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'look-modal__dot' + (i === 0 ? ' is-active' : '');
        dotsContainer.appendChild(dot);
      }
      dotsContainer.style.display = count <= 1 ? 'none' : '';
    }

    function updatePrice() {
      if (!priceEl || !currentProduct) return;
      var variant = findVariant(selectedOptions);
      if (!variant) { priceEl.textContent = ''; return; }
      var onSale = variant.compare_at_price != null && variant.compare_at_price > variant.price;
      if (onSale) {
        priceEl.innerHTML = '<span class="look-modal__price-compare">' +
          formatMoney(variant.compare_at_price) + '</span>' + formatMoney(variant.price);
      } else {
        priceEl.textContent = formatMoney(variant.price);
      }
    }

    function updateSoldOut() {
      if (!currentProduct) return;
      var sizeBtns = optionsEl.querySelectorAll('.look-modal__size-btn');
      sizeBtns.forEach(function(btn) {
        var pos = btn.getAttribute('data-option-position');
        var val = btn.getAttribute('data-value');
        var hypo = {};
        for (var k in selectedOptions) hypo[k] = selectedOptions[k];
        hypo[pos] = val;
        var v = findVariant(hypo);
        var soldOut = !v || !v.available;
        btn.classList.toggle('is-sold-out', soldOut);
        btn.disabled = soldOut;
      });
    }

    function updateAtcButton() {
      var variant = findVariant(selectedOptions);
      if (variant && variant.available) {
        atcBtn.disabled = false;
        atcBtn.textContent = addLabel;
      } else {
        atcBtn.disabled = true;
        atcBtn.textContent = soldOutLabel;
      }
    }

    function getSelectedColor() {
      if (!currentProduct || !currentProduct.has_color_filter) return null;
      var colorPos = null;
      currentProduct.options_with_values.forEach(function(opt) {
        if (isColorOption(opt.name)) colorPos = opt.position;
      });
      return colorPos ? (selectedOptions[colorPos] || null) : null;
    }

    function buildOptions() {
      optionsEl.innerHTML = '';
      if (!currentProduct || !currentProduct.options_with_values) return;
      if (currentProduct.options_with_values.length === 1 && currentProduct.variants.length === 1) return;

      currentProduct.options_with_values.forEach(function(option) {
        var isColor = isColorOption(option.name);
        var group = document.createElement('div');
        group.className = 'look-modal__option-group';

        var label = document.createElement('p');
        label.className = 'look-modal__option-label';
        label.textContent = isColor ? colorLabel : sizeLabel;
        group.appendChild(label);

        var values = document.createElement('div');
        values.className = 'look-modal__option-values';

        option.values.forEach(function(val, i) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.setAttribute('data-option-position', option.position);
          btn.setAttribute('data-value', val);

          if (isColor) {
            btn.className = 'look-modal__color-btn';
            btn.title = val;
            btn.setAttribute('aria-label', val);
            var fill = document.createElement('span');
            fill.className = 'look-modal__color-fill';
            fill.style.background = val.toLowerCase().replace(/\s+/g, '');
            btn.appendChild(fill);
          } else {
            btn.className = 'look-modal__size-btn';
            btn.textContent = val;
          }

          if (i === 0) {
            btn.classList.add('is-active');
            selectedOptions[option.position] = val;
          }

          btn.addEventListener('click', function() {
            if (this.disabled && !isColor) return;
            var pos = this.getAttribute('data-option-position');
            var clickedVal = this.getAttribute('data-value');

            if (isColor && currentProduct) {
              selectedOptions[pos] = clickedVal;
              var firstVariant = currentProduct.variants.find(function(v) {
                return v['option' + pos] === clickedVal;
              });
              if (firstVariant) {
                for (var p = 1; p <= 3; p++) {
                  if (firstVariant['option' + p] !== undefined && firstVariant['option' + p] !== null) {
                    selectedOptions[p] = firstVariant['option' + p];
                  }
                }
              }
              optionsEl.querySelectorAll('.look-modal__size-btn').forEach(function(b) {
                b.classList.remove('is-active');
              });
              var newSizeVal = selectedOptions[pos === '1' || pos === 1 ? 2 : 1];
              if (newSizeVal) {
                optionsEl.querySelectorAll('.look-modal__size-btn').forEach(function(b) {
                  if (b.getAttribute('data-value') === String(newSizeVal)) {
                    b.classList.add('is-active');
                  }
                });
              }
            } else {
              selectedOptions[pos] = clickedVal;
            }

            var siblings = values.querySelectorAll('[data-option-position="' + pos + '"]');
            siblings.forEach(function(s) { s.classList.remove('is-active'); });
            this.classList.add('is-active');

            if (isColor && currentProduct.has_color_filter) {
              filterByColor(clickedVal);
            }

            updateSoldOut();
            updatePrice();
            updateAtcButton();
          });

          values.appendChild(btn);
        });

        group.appendChild(values);
        optionsEl.appendChild(group);
      });
    }

    function openModal(index) {
      var jsonEl = section.querySelector('[data-look-product="' + index + '"]');
      var tpl = section.querySelector('template[data-look-media="' + index + '"]');
      if (!jsonEl || !tpl) return;

      try { currentProduct = JSON.parse(jsonEl.textContent); } catch(e) { return; }
      selectedOptions = {};

      titleEl.textContent = currentProduct.title;
      carousel.innerHTML = '';
      dotsContainer.innerHTML = '';

      var fragment = tpl.content.cloneNode(true);
      var slides = Array.prototype.slice.call(fragment.querySelectorAll('.look-modal__slide'));
      slides.forEach(function(slide) { carousel.appendChild(slide); });

      buildOptions();

      if (currentProduct.has_color_filter && currentProduct.color_ranges && currentProduct.color_ranges.length > 0) {
        assignColorGroups();
        filterByColor(getSelectedColor());
      } else {
        slides.sort(function(a, b) {
          var aV = a.getAttribute('data-media-type') !== 'image';
          var bV = b.getAttribute('data-media-type') !== 'image';
          if (aV && !bV) return -1;
          if (!aV && bV) return 1;
          return 0;
        });
        slides.forEach(function(s) { carousel.appendChild(s); });
        rebuildDots(slides.length);

        if (slides.length > 0) {
          var firstVideo = slides[0].querySelector('video');
          if (firstVideo) {
            firstVideo.autoplay = true;
            firstVideo.muted = true;
            try { firstVideo.play(); } catch(e) {}
          }
        }
      }

      updatePrice();
      updateSoldOut();
      updateAtcButton();

      overlay.classList.add('is-open');
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      overlay.classList.remove('is-open');
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      carousel.querySelectorAll('video').forEach(function(v) { v.pause(); });
      carousel.innerHTML = '';
      dotsContainer.innerHTML = '';
      currentProduct = null;
      selectedOptions = {};
    }

    section.querySelectorAll('.product-look__card[data-look-index]').forEach(function(card) {
      card.addEventListener('click', function(e) {
        e.preventDefault();
        openModal(this.getAttribute('data-look-index'));
      });
    });

    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', closeModal);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    carousel.addEventListener('scroll', function() {
      var visible = getVisibleSlides();
      if (visible.length === 0) return;
      var slideWidth = visible[0].offsetWidth;
      var activeIdx = Math.min(Math.round(carousel.scrollLeft / slideWidth), visible.length - 1);
      dotsContainer.querySelectorAll('.look-modal__dot').forEach(function(d, i) {
        d.classList.toggle('is-active', i === activeIdx);
      });
      visible.forEach(function(slide, i) {
        var video = slide.querySelector('video');
        if (!video) return;
        if (i === activeIdx) {
          try { video.play(); } catch(e) {}
        } else {
          video.pause();
        }
      });
    }, { passive: true });

    dotsContainer.addEventListener('click', function(e) {
      var dot = e.target.closest('.look-modal__dot');
      if (!dot) return;
      var dots = dotsContainer.querySelectorAll('.look-modal__dot');
      var idx = Array.prototype.indexOf.call(dots, dot);
      var visible = getVisibleSlides();
      if (idx >= 0 && visible[idx]) {
        carousel.scrollTo({ left: visible[idx].offsetLeft, behavior: 'smooth' });
      }
    });

    atcBtn.addEventListener('click', function() {
      if (this.disabled) return;
      var variant = findVariant(selectedOptions);
      if (!variant || !variant.available) return;
      if (window.CartDrawer) {
        CartDrawer.addItem(variant.id, 1);
        closeModal();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  function setupRecommendationsScroll(section) {
    var grid = section && section.querySelector('#product-recommendations');
    var prevBtn = section && section.querySelector('.recommendations__arrow--prev');
    var nextBtn = section && section.querySelector('.recommendations__arrow--next');
    if (!grid || !prevBtn || !nextBtn) return;
    function getScrollAmount() {
      var first = grid.querySelector('.product-card');
      if (!first) return grid.offsetWidth * 0.8;
      var gap = parseFloat(getComputedStyle(grid).gap) || 16;
      return first.offsetWidth + gap;
    }
    function updateArrows() {
      prevBtn.disabled = grid.scrollLeft <= 2;
      nextBtn.disabled = grid.scrollLeft + grid.offsetWidth >= grid.scrollWidth - 2;
    }
    prevBtn.addEventListener('click', function() { grid.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' }); });
    nextBtn.addEventListener('click', function() { grid.scrollBy({ left: getScrollAmount(), behavior: 'smooth' }); });
    grid.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  }

  var section = document.querySelector('.recommendations');
  if (section) setupRecommendationsScroll(section);

  var container = document.getElementById('product-recommendations');
  if (container) {
    var url = container.dataset.url + '&intent=related';
    fetch(url)
      .then(function(res) { return res.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.getElementById('product-recommendations');
        if (fresh && fresh.innerHTML.trim().length) {
          container.innerHTML = fresh.innerHTML;
          if (section) setupRecommendationsScroll(section);
        }
      })
      .catch(function() {});
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["share-the-look"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var container = document.getElementById('share-the-look');
    if (!container) return;

    var baseUrl = container.dataset.baseUrl || (window.location.origin + window.location.pathname);
    var currency = container.dataset.currency || '';
    var copiedLabel = container.dataset.copyLabel || 'Link copied';

    var builder = document.getElementById('share-the-look-builder');
    var view = document.getElementById('share-the-look-view');
    var resultsEl = document.getElementById('share-the-look-results');
    var resultsEmpty = document.getElementById('share-the-look-results-empty');
    var countEl = document.getElementById('share-the-look-count');
    var listEl = document.getElementById('share-the-look-list');
    var copyBtn = document.getElementById('share-the-look-copy');
    var viewGrid = document.getElementById('share-the-look-view-grid');
    var searchInput = document.getElementById('share-the-look-search');

    var selected = [];
    var searchDebounce = null;

    function getProductsParam() {
      var params = new URLSearchParams(window.location.search);
      var p = params.get('products');
      return p ? p.split(',').map(function(h) { return h.trim(); }).filter(Boolean) : [];
    }

    function formatMoney(cents) {
      if (currency) {
        return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + currency;
      }
      return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function renderSharedView(handles) {
      if (!handles.length) return;
      viewGrid.innerHTML = '';
      view.hidden = false;
      if (builder) builder.hidden = true;

      handles.forEach(function(handle) {
        fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function(r) { return r.json(); })
          .then(function(product) {
            var card = document.createElement('div');
            card.className = 'share-the-look__view-card';
            var imgSrc = product.featured_image || '';
            var imgHtml = imgSrc ? '<img src="' + imgSrc.replace(/"/g, '&quot;') + '" alt="" loading="lazy">' : '';
            var price = product.price != null ? product.price : 0;
            var compare = product.compare_at_price != null ? product.compare_at_price : 0;
            var priceHtml = (compare > 0 && price < compare)
              ? '<span class="product-card__compare-at-price">' + formatMoney(compare) + '</span><span class="product-card__sale-price">' + formatMoney(price) + '</span>'
              : formatMoney(price);
            var title = (product.title || '').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
            var url = (product.url || '/products/' + handle).replace(/"/g, '&quot;');
            card.innerHTML =
              '<a href="' + url + '" class="product-card">' +
                '<div class="product-card__media">' +
                  '<div class="product-card__image product-card__image--primary">' + imgHtml + '</div>' +
                '</div>' +
                '<div class="product-card__info">' +
                  '<p class="product-card__title">' + title + '</p>' +
                  '<p class="product-card__price">' + priceHtml + '</p>' +
                '</div>' +
              '</a>';
            viewGrid.appendChild(card);
          })
          .catch(function() {});
      });
    }

    function updateUrl(handles) {
      var url = baseUrl;
      if (handles.length) url += '?products=' + handles.join(',');
      if (typeof history.replaceState !== 'undefined') {
        history.replaceState({}, '', url);
      }
    }

    var sidebarEl = document.getElementById('share-the-look-sidebar');
    function renderList() {
      countEl.textContent = selected.length;
      if (sidebarEl) {
        sidebarEl.classList.toggle('share-the-look__sidebar--hidden', selected.length === 0);
      }
      if (selected.length === 0) {
        listEl.innerHTML = '';
        return;
      }
      listEl.innerHTML = selected.map(function(item, i) {
        var img = item.image
          ? '<img src="' + item.image.replace(/&/g, '&amp;') + '&width=96" alt="" width="48" height="48">'
          : '';
        var title = (item.title || '').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
        return '<li class="share-the-look__list-item" data-index="' + i + '">' +
          '<div class="share-the-look__list-thumb">' + img + '</div>' +
          '<div class="share-the-look__list-info"><p class="share-the-look__list-title">' + title + '</p></div>' +
          '<button type="button" class="share-the-look__list-remove" aria-label="Remove">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button></li>';
      }).join('');

      listEl.querySelectorAll('.share-the-look__list-remove').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var li = btn.closest('.share-the-look__list-item');
          var idx = parseInt(li.dataset.index, 10);
          selected.splice(idx, 1);
          updateUrl(selected.map(function(s) { return s.handle; }));
          renderList();
        });
      });
    }

    function addSelected(product) {
      var handle = product.handle || (product.url && product.url.split('/products/')[1]);
      if (!handle) return;
      if (selected.some(function(s) { return s.handle === handle; })) return;
      selected.push({
        handle: handle,
        title: product.title,
        image: product.image,
        price: product.price,
        compare_at_price_min: product.compare_at_price_min
      });
      updateUrl(selected.map(function(s) { return s.handle; }));
      renderList();
    }

    function doSearch(query) {
      if (!query || query.length < 2) {
        resultsEmpty.hidden = false;
        resultsEmpty.textContent = container.dataset.searchHint || 'Search for products...';
        var grid = resultsEl.querySelector('.share-the-look__results-grid');
        if (grid) grid.remove();
        return;
      }
      resultsEmpty.hidden = true;
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=12')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) ? data.resources.results.products : [];
          var grid = resultsEl.querySelector('.share-the-look__results-grid');
          if (grid) grid.remove();
          if (products.length === 0) {
            resultsEmpty.hidden = false;
            resultsEmpty.textContent = container.dataset.noResults || 'No products found.';
            return;
          }
          grid = document.createElement('div');
          grid.className = 'share-the-look__results-grid';
          products.forEach(function(p) {
            var handle = p.handle || (p.url && p.url.split('/products/')[1]);
            if (!handle) return;
            var priceVal = parseFloat(p.price) || 0;
            var compareVal = parseFloat(p.compare_at_price_min) || 0;
            var onSale = compareVal > 0 && priceVal < compareVal;
            var formatPrice = function(val) {
              return (currency ? (val).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + currency : (val).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
            };
            var img = p.image ? '<img src="' + (p.image + '&width=400').replace(/&/g, '&amp;') + '" alt="" loading="lazy">' : '';
            var title = (p.title || '').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
            var priceHtml = onSale
              ? '<span class="compare-at">' + formatPrice(compareVal) + '</span> <span class="sale">' + formatPrice(priceVal) + '</span>'
              : formatPrice(priceVal);
            var card = document.createElement('div');
            card.className = 'share-the-look__result-card';
            card.innerHTML =
              '<a href="' + (p.url || '/products/' + handle) + '" class="share-the-look__result-link">' +
                '<div class="share-the-look__result-image">' + img + '</div>' +
                '<div class="share-the-look__result-info">' +
                  '<p class="share-the-look__result-title">' + title + '</p>' +
                  '<p class="share-the-look__result-price">' + priceHtml + '</p>' +
                '</div>' +
              '</a>' +
              '<button type="button" class="share-the-look__result-add" aria-label="Add to list" data-handle="' + handle.replace(/"/g, '&quot;') + '" data-title="' + title.replace(/"/g, '&quot;') + '" data-image="' + (p.image || '').replace(/"/g, '&quot;') + '" data-price="' + (p.price || '') + '" data-compare="' + (p.compare_at_price_min || '') + '">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
              '</button>';
            grid.appendChild(card);
          });
          resultsEl.appendChild(grid);
          grid.querySelectorAll('.share-the-look__result-add').forEach(function(btn) {
            btn.addEventListener('click', function(e) {
              e.preventDefault();
              addSelected({
                handle: btn.dataset.handle,
                title: btn.dataset.title,
                image: btn.dataset.image,
                price: btn.dataset.price,
                compare_at_price_min: btn.dataset.compare
              });
            });
          });
        })
        .catch(function() {
          resultsEmpty.hidden = false;
          resultsEmpty.textContent = container.dataset.noResults || 'Search failed. Try again.';
        });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function() {
        var q = searchInput.value.trim();
        clearTimeout(searchDebounce);
        searchDebounce = setTimeout(function() { doSearch(q); }, 300);
      });
    }

    function showCopiedFeedback() {
      var originalText = copyBtn.textContent;
      copyBtn.textContent = copiedLabel;
      copyBtn.disabled = true;
      setTimeout(function() {
        copyBtn.textContent = originalText;
        copyBtn.disabled = false;
      }, 2000);
    }

    function fallbackCopy(url) {
      var ta = document.createElement('textarea');
      ta.value = url;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      ta.style.top = '0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      try {
        var ok = document.execCommand('copy');
        document.body.removeChild(ta);
        return ok;
      } catch (e) {
        document.body.removeChild(ta);
        return false;
      }
    }

    copyBtn.addEventListener('click', function() {
      var handles = selected.map(function(s) { return s.handle; });
      var url = handles.length ? baseUrl + '?products=' + handles.join(',') : baseUrl;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url)
          .then(function() {
            showCopiedFeedback();
          })
          .catch(function() {
            if (fallbackCopy(url)) showCopiedFeedback();
          });
      } else {
        if (fallbackCopy(url)) showCopiedFeedback();
      }
    });

    var urlHandles = getProductsParam();
    if (urlHandles.length > 0) {
      selected = urlHandles.map(function(h) { return { handle: h, title: '', image: '' }; });
      renderSharedView(urlHandles);
    } else {
      renderList();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teamwear-form"]) return;
  try {
    
  (function () {
    var openBtn = document.getElementById('teamwear-size-chart-open');
    var closeBtn = document.getElementById('teamwear-size-chart-close');
    var modal = document.getElementById('teamwear-size-chart-modal');
    var overlay = document.getElementById('teamwear-size-chart-overlay');
    if (!openBtn || !modal || !overlay) return;

    var lastFocused = null;

    function openSizeChart() {
      lastFocused = document.activeElement;
      overlay.hidden = false;
      modal.hidden = false;
      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (closeBtn) closeBtn.focus();
      });
    }

    function closeSizeChart() {
      overlay.classList.remove('is-open');
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      window.setTimeout(function () {
        overlay.hidden = true;
        modal.hidden = true;
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      }, 300);
    }

    openBtn.addEventListener('click', openSizeChart);
    if (closeBtn) closeBtn.addEventListener('click', closeSizeChart);
    overlay.addEventListener('click', closeSizeChart);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeSizeChart();
    });
  })();

  (function () {
    var uploaders = document.querySelectorAll('[data-uploader]');

    uploaders.forEach(function (uploader) {
      var input = uploader.querySelector('[data-file-input]');
      var dropzone = uploader.querySelector('[data-dropzone]');
      var list = uploader.querySelector('[data-file-list]');
      var errorEl = uploader.querySelector('[data-file-error]');
      if (!input || !list) return;

      var removeLabel = uploader.dataset.removeLabel || 'Remove';
      var maxFiles = parseInt(input.dataset.maxFiles, 10) || 10;
      var maxSize = parseInt(input.dataset.maxSize, 10) || 10485760;
      var allowed = ['image/jpeg', 'image/png', 'application/pdf'];
      var files = [];

      function showError(msg) {
        if (!errorEl) return;
        errorEl.textContent = msg || '';
        errorEl.hidden = !msg;
      }

      function formatSize(bytes) {
        if (bytes >= 1048576) return (bytes / 1048576).toFixed(1) + ' MB';
        if (bytes >= 1024) return Math.round(bytes / 1024) + ' KB';
        return bytes + ' B';
      }

      function syncInput() {
        var dt = new DataTransfer();
        files.forEach(function (file) {
          dt.items.add(file);
        });
        input.files = dt.files;
      }

      function render() {
        list.innerHTML = '';
        list.hidden = files.length === 0;

        files.forEach(function (file, index) {
          var item = document.createElement('li');
          item.className = 'teamwear__file-item';

          var thumb;
          if (file.type === 'image/jpeg' || file.type === 'image/png') {
            thumb = document.createElement('img');
            thumb.className = 'teamwear__file-thumb';
            thumb.alt = file.name;
            thumb.src = URL.createObjectURL(file);
            thumb.addEventListener('load', function () {
              URL.revokeObjectURL(thumb.src);
            });
          } else {
            thumb = document.createElement('span');
            thumb.className = 'teamwear__file-thumb';
            var ext = file.name.split('.').pop();
            thumb.textContent = ext ? ext.slice(0, 4) : 'FILE';
          }

          var info = document.createElement('div');
          info.className = 'teamwear__file-info';

          var name = document.createElement('span');
          name.className = 'teamwear__file-name';
          name.textContent = file.name;

          var size = document.createElement('span');
          size.className = 'teamwear__file-size';
          size.textContent = formatSize(file.size);

          info.appendChild(name);
          info.appendChild(size);

          var remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'teamwear__file-remove';
          remove.setAttribute('aria-label', removeLabel + ' ' + file.name);
          remove.innerHTML =
            '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
          remove.addEventListener('click', function () {
            files.splice(index, 1);
            syncInput();
            render();
          });

          item.appendChild(thumb);
          item.appendChild(info);
          item.appendChild(remove);
          list.appendChild(item);
        });
      }

      function addFiles(fileList) {
        var errors = [];
        Array.prototype.forEach.call(fileList, function (file) {
          var isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name);
          var typeOk = allowed.indexOf(file.type) !== -1 || isPdf;
          if (!typeOk) {
            errors.push(uploader.dataset.errType || ('Unsupported file: ' + file.name));
            return;
          }
          if (file.size > maxSize) {
            errors.push((uploader.dataset.errSize || 'File too large') + ': ' + file.name);
            return;
          }
          var duplicate = files.some(function (existing) {
            return (
              existing.name === file.name &&
              existing.size === file.size &&
              existing.lastModified === file.lastModified
            );
          });
          if (duplicate) return;
          if (files.length >= maxFiles) {
            errors.push(uploader.dataset.errCount || ('Maximum ' + maxFiles + ' files'));
            return;
          }
          files.push(file);
        });
        showError(errors.length ? errors[0] : '');
        syncInput();
        render();
      }

      input.addEventListener('change', function () {
        if (input.files && input.files.length) {
          addFiles(input.files);
        }
      });

      uploader.addEventListener('teamwear:reset', function () {
        files = [];
        showError('');
        syncInput();
        render();
      });

      ['dragenter', 'dragover'].forEach(function (evt) {
        dropzone.addEventListener(evt, function (e) {
          e.preventDefault();
          uploader.classList.add('is-dragover');
        });
      });

      ['dragleave', 'drop'].forEach(function (evt) {
        dropzone.addEventListener(evt, function (e) {
          e.preventDefault();
          uploader.classList.remove('is-dragover');
        });
      });

      dropzone.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files.length) {
          addFiles(e.dataTransfer.files);
        }
      });
    });
  })();

  (function () {
    var form = document.querySelector('[data-teamwear-form]');
    if (!form) return;

    var endpoint = form.dataset.endpoint;
    var submitBtn = form.querySelector('[data-submit-btn]');
    var submitLabel = form.querySelector('[data-submit-label]');
    var successEl = form.querySelector('[data-form-success]');
    var errorEl = form.querySelector('[data-form-error]');
    var defaultLabel = submitLabel ? submitLabel.textContent : '';
    var submittingLabel = form.dataset.msgSubmitting || 'Submitting…';
    var artworkRadios = form.querySelectorAll('[data-artwork]');
    var logoReq = form.querySelector('[data-logo-req]');
    var fileInput = form.querySelector('[data-file-input]');

    function artworkValue() {
      var checked = form.querySelector('[data-artwork]:checked');
      return checked ? checked.value : '';
    }

    function syncLogoRequirement() {
      if (logoReq) logoReq.hidden = artworkValue() !== 'yes';
    }

    artworkRadios.forEach(function (radio) {
      radio.addEventListener('change', syncLogoRequirement);
    });
    syncLogoRequirement();

    function setBusy(busy) {
      if (submitBtn) submitBtn.disabled = busy;
      if (submitLabel) submitLabel.textContent = busy ? submittingLabel : defaultLabel;
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = !msg;
      if (msg) errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function showSuccess() {
      if (successEl) {
        successEl.hidden = false;
        successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!endpoint) {
        showError(form.dataset.msgError);
        return;
      }

      if (artworkValue() === 'yes' && (!fileInput || !fileInput.files.length)) {
        showError(form.dataset.msgFilesRequired);
        if (fileInput) {
          var dz = form.querySelector('[data-dropzone]');
          (dz || fileInput).scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      showError('');
      if (successEl) successEl.hidden = true;
      setBusy(true);

      var raw = new FormData(form);
      var data = new FormData();
      raw.forEach(function (value, key) {
        if (value instanceof File) {
          if (value.size > 0) data.append(key, value);
        } else if (String(value).trim() !== '') {
          data.append(key, value);
        }
      });

      fetch(endpoint, { method: 'POST', body: data })
        .then(function (response) {
          return response
            .json()
            .catch(function () {
              return {};
            })
            .then(function (body) {
              return { status: response.status, ok: response.ok, body: body };
            });
        })
        .then(function (result) {
          if (result.ok && result.body && result.body.success) {
            form.reset();
            form.querySelectorAll('[data-uploader]').forEach(function (uploader) {
              uploader.dispatchEvent(new CustomEvent('teamwear:reset'));
            });
            showSuccess();
            return;
          }

          if (result.status === 429) {
            showError(form.dataset.msgRateLimit);
            return;
          }

          var apiMsg = result.body && (result.body.error || result.body.message);
          showError(apiMsg || form.dataset.msgError);
        })
        .catch(function () {
          showError(form.dataset.msgError);
        })
        .then(function () {
          setBusy(false);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unisex-category-images"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.ucategory-section').forEach(function(section) {
      var sectionId = section.getAttribute('data-section-id');
      var toggleBtns = section.querySelectorAll('.ucategory__toggle-btn');
      var mensGrid = document.getElementById('ucategory-track-mens-' + sectionId);
      var womensGrid = document.getElementById('ucategory-track-womens-' + sectionId);
      var prevBtn = section.querySelector('.ucategory__arrow--prev');
      var nextBtn = section.querySelector('.ucategory__arrow--next');

      function getActiveTrack() {
        return section.querySelector('.ucategory__grid.is-active');
      }

      function getScrollAmount() {
        var track = getActiveTrack();
        if (!track) return 0;
        var first = track.querySelector('.ucategory__item');
        if (!first) return track.offsetWidth * 0.8;
        var gap = parseFloat(getComputedStyle(track).gap) || 20;
        return first.offsetWidth + gap;
      }

      function updateArrows() {
        var track = getActiveTrack();
        if (!prevBtn || !nextBtn || !track) return;
        var canScroll = track.scrollWidth > track.offsetWidth + 2;
        prevBtn.disabled = track.scrollLeft <= 2;
        nextBtn.disabled = !canScroll || track.scrollLeft + track.offsetWidth >= track.scrollWidth - 2;
      }

      toggleBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var gender = this.getAttribute('data-gender');
          toggleBtns.forEach(function(b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
          });
          this.classList.add('is-active');
          this.setAttribute('aria-selected', 'true');

          if (gender === 'mens') {
            mensGrid.classList.add('is-active');
            mensGrid.removeAttribute('hidden');
            womensGrid.classList.remove('is-active');
            womensGrid.setAttribute('hidden', '');
          } else {
            womensGrid.classList.add('is-active');
            womensGrid.removeAttribute('hidden');
            mensGrid.classList.remove('is-active');
            mensGrid.setAttribute('hidden', '');
          }

          var track = getActiveTrack();
          if (track) track.scrollTo(0, 0);
          updateArrows();
        });
      });

      if (prevBtn && nextBtn) {
        prevBtn.addEventListener('click', function() {
          var track = getActiveTrack();
          if (track) track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });
        nextBtn.addEventListener('click', function() {
          var track = getActiveTrack();
          if (track) track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });
      }

      if (mensGrid) mensGrid.addEventListener('scroll', updateArrows, { passive: true });
      if (womensGrid) womensGrid.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
